<div class="controls-container">
    <a *ngIf="!hideEditButton" class="btn-edit" (click)="editComponent()">
        <mat-icon svgIcon="unh_text_edit"></mat-icon>
    </a>
    <a (click)="deleteComponent()">
        <mat-icon svgIcon="unh_forum_delete_component"></mat-icon>
    </a>
</div>